// export const singer = state => state.singer

export const showDialog = state => state.showDialog

export const netWorkError = state => state.netWorkError

export const netWorkCode = state => state.netWorkCode


